import { render, staticRenderFns } from "./PowerBIList.vue?vue&type=template&id=544f16d8&"
import script from "./PowerBIList.vue?vue&type=script&lang=js&"
export * from "./PowerBIList.vue?vue&type=script&lang=js&"
import style0 from "./PowerBIList.vue?vue&type=style&index=0&id=544f16d8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports